import { render, staticRenderFns } from "./pod.vue?vue&type=template&id=65563422&scoped=true&"
import script from "./pod.vue?vue&type=script&lang=js&"
export * from "./pod.vue?vue&type=script&lang=js&"
import style0 from "./pod.vue?vue&type=style&index=0&id=65563422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65563422",
  null
  
)

export default component.exports